/*
Agregar dos inputs, codigo y cantidad
esos inputs pasan a una tabla
la tabla es read only (copiar como en formato facturacion)

Imprimir esos QRs
*/
import React from 'react'
import TextField from '@material-ui/core/TextField';
import InputBase from '@material-ui/core/InputBase';
import NewWindow from 'react-new-window'
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { QrApi } from '../../api/qrApi'
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import MemoryIcon from '@material-ui/icons/Memory';
import Notification from '../Notifications'

var QRCode = require('qrcode.react');

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
}));

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
}


export class QrsView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            qrs: [], // contains a list of {'id': 1, 'description':'sdasd', 'qty':2}
            openPrintQr: false,
            product: null,
            qty:null,
            msg: null,
            msgType: null,
            showMsg: false,
            open: false
        }

    }
    componentDidMount = () => {
      this.loadQrs()
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false });
    }
    // {'created_on': '2021-07-11 14:19:44', 'updated_on': '2021-07-11 14:19:44', 'id': 1,
    // 'items': 2, 'product_type_id': 1, 'product_id': 1, 'product_description': 'apple yfmseroytoezccdrxzalbziwydgoez',
    // 'product_type': 'ngRtpvGwpJmBXsBrMwsFvbBlEvUeRk'}
    loadQrs = () => {
      QrApi.getQrs()
      .then(response => {
        return response.data

    })
    .then((data) => {
        this.setState({ qrs: data })
    })
    .catch(error =>{
      console.log(error)

    })
    }

    searchProduct = () => {
        console.log('PRODUCT: ' + this.state.product)
    }

    getQrs = () =>{
        let qrs = []

        if(this.state.openPrintQr){
            this.state.qrs.map(qr =>{
                for(let i=0; i < qr.items; i++ ){
                  qrs.push(<div style={{marginLeft:25,  marginRight:15, marginTop:1}}>
                      <Typography style={{marginLeft: 5, marginTop:-20}} variant="caption">
                                  {qr.product_id.toString()}
                              </Typography>
                      <div class="grid-child green" >

                              <QRCode
                                  size={38}
                                  quality={1}
                                  errorCorrectionLevel={'high'}
                                  renderAs={'svg'}
                                  version={40}
                                  level={"H"}
                                  value={qr.product_id.toString()}
                                  >
                              </QRCode>

                          </div>
                          </div>  )
                  }
            })

        }
        return qrs
    }
    donePrinting = () =>{
        this.setState({ openPrintQr: false })
    }
    deleteQr = (id) =>{
      QrApi.deleteQr(id)
      .then(response=>{
        this.loadQrs()
      })
      .catch(error =>{
        console.log('error')
      })
    }
    addQr = () => {
      // hacer un post del nuevo QR, llamar a loadQrs
      // validar que el codigo no sea null ni la candidad sea 0
      if(this.state.qty === null || this.state.qty < 1){
        this.setState({open: !this.state.open, msg: 'Cantidad invalida', msgType: 'error'})
        return
      }
      if(this.state.product === null || this.state.product < 1){
        this.setState({open: !this.state.open, msg: 'Producto invalido', msgType: 'error'})
        return
      }
      QrApi.createQr({product: this.state.product, items: this.state.qty})
      .then(response =>{
          this.setState({open: !this.state.open, msg: 'Qr Agregado', msgType: 'success'})
          this.loadQrs()
      })
      .catch(error =>{
        console.log(error)
        this.setState({open: !this.state.open, msg: 'Intente nuevamente', msgType: 'error'})

      })
    }
    qrTable = () => {
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="center"><b>Codigo</b></TableCell>
                        <TableCell align="center"><b>Tipo de Producto</b></TableCell>
                        <TableCell align="center"><b>Producto</b></TableCell>
                        <TableCell align="center"><b>Cantidad</b></TableCell>
                        <TableCell align="center"><b>Remover</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.qrs.map((row) => (
                        <TableRow key={row.id}>
                            <TableCell align="center">{row.product_id}</TableCell>
                            <TableCell align="center">{row.product_type}</TableCell>
                            <TableCell align="center">{row.product_description}</TableCell>
                            <TableCell align="center">{row.items}</TableCell>
                            <TableCell align="center">
                            <IconButton aria-label="Search"
                                onClick={(e) => this.deleteQr(row.id)}>
                                <DeleteIcon />
                            </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}

                </TableBody>

            </Table>
        );
    }
    clearQrs = () =>{
      QrApi.purgeQrs()
      .then(response =>{
        this.setState({qrs:[]})
        this.setState({open: !this.state.open, msg: 'Qr Eliminados', msgType: 'success'})

      })
    }

    render = () => {
        return (
          <div>
              <div className="col-md-12" style={{ marginTop: 20 }}>
                <div className="col-md-2">
                  <TextField
                      label="Codigo"
                      onChange={(e) => {this.setState({product: parseInt(e.target.value)})}}
                      style={{ marginLeft: 15 }}
                      type="number"
                      InputProps={{ inputProps: { min: 1, max: 999999 } }}
                      value={this.state.product}

                  />
                </div>
                <div className="col-md-2" style={{ marginLeft: -20 }}>
                  <TextField
                      label="Cantidad"
                      onChange={(e) => {this.setState({qty: parseInt(e.target.value)})}}
                      style={{ marginLeft: 15 }}
                      type="number"
                      InputProps={{ inputProps: { min: 1, max: 999 } }}
                      value={this.state.qty}

                  />
                </div>
                <div className="col-md-1 " style={{ marginTop: 10 }}>
                  <IconButton onClick={(e) =>{this.addQr()}} aria-label="Search">
                      <MemoryIcon />

                  </IconButton>
              </div>
              <div className="col-md-1 col-md-offset-6" style={{ marginTop: 5 }}>
                <IconButton aria-label="Delete"
                    onClick={(e) => this.clearQrs()}>
                    <DeleteIcon />
                </IconButton>
              </div>
              </div>
              <div className="col-md-12" style={{ marginTop: 10 }}>
                  {this.qrTable()}
              </div>
              <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => this.setState({openPrintQr: true})}
              >
                  Generar QRs
              </Button>
              {this.state.openPrintQr &&
              <NewWindow onUnload={this.donePrinting}>
                  <div class="grid-container">
                  {this.getQrs()}
                  </div>
                  </NewWindow>
              }
              <Notification
                  open={this.state.open}
                  variant={this.state.msgType}
                  message={this.state.msg}
                  onClose={this.handleClose}
              />

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Products/Qrs.js